import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, useEffect, useState } from "react";
import BlockUi from "react-block-ui";
import Loader from "react-loader-spinner";
import { useParams } from "react-router-dom";
import { baseUrl, JWT, MoneyMask, respuestaEpayco, XHR } from "../../helpers";

const DescargarComprobantePago: FC = () => {
  const a: respuestaEpayco = {
    x_cust_id_cliente: "",
    x_ref_payco: "",
    x_id_factura: "",
    x_id_invoice: "",
    x_description: "",
    x_amount: 0,
    x_amount_country: 0,
    x_amount_ok: 0,
    x_tax: 0,
    x_tax_ico: 0,
    x_amount_base: "",
    x_currency_code: "",
    x_bank_name: "",
    x_cardnumber: "",
    x_quotas: "",
    x_respuesta: "",
    x_response: "",
    x_approval_code: "",
    x_transaction_id: "",
    x_fecha_transaccion: "",
    x_transaction_date: "",
    x_cod_respuesta: "",
    x_cod_response: "",
    x_response_reason_text: "",
    x_cod_transaction_state: "",
    x_transaction_state: "",
    x_errorcode: "",
    x_franchise: "",
    x_business: "",
    x_customer_doctype: "",
    x_customer_document: "",
    x_customer_name: "",
    x_customer_lastname: "",
    x_customer_email: "",
    x_customer_phone: "",
    x_customer_movil: "",
    x_customer_ind_pais: "",
    x_customer_country: "",
    x_customer_city: "",
    x_customer_address: "",
    x_customer_ip: "",
    x_signature: "",
    x_test_request: "",
    x_extra1: "",
    x_extra2: "",
    x_extra3: "",
    x_extra4: "",
    x_extra5: "",
    x_extra6: "",
    x_extra7: "",
    x_extra8: "",
    x_extra9: "",
    x_extra10: "",
    x_type_payment: "",
  };

  const parametrosURL = useParams();
  const [pantallaBloqueada, setPantallaBloqueada] = useState(false);
  const [respEpayco, setRespEPayco] = useState(a);
  const [nombreDashboard, setNombreDashboard] = useState(null);
  const [ipoconsumo, setIpoconsumo] = useState(0);
  const [resultadoVacio, setresultadoVacio] = useState(false);
  let [contador, setContador] = useState(16);
  //let contador = 16;

  const _loader = (
    <Loader type="TailSpin" color="#164192" height={80} width={80} />
  );

  const ref_payco = parametrosURL.ref_payco;
  const id_cliente = parametrosURL.id_cliente;

  useEffect(() => {
    const consultarDetalleRefEpayco = async (
      stpb: React.Dispatch<React.SetStateAction<boolean>>
    ) => {
      ///alert(ref_payco + " " + id_cliente);
      const token = await JWT("PAGOS_EN_LINEA");
      var _headers = { Authorization: "Bearer " + token };
      const _url =
        baseUrl() +
        "Transacciones/consultarDetalleRefEpayco/" +
        ref_payco +
        "/" +
        id_cliente;
      var resp = await XHR(stpb, _url, {}, "get", _headers);
      //console.log(resp?.data.data.data.log);
      if(resp?.data.data.data.log.length == 0){
          setresultadoVacio(true);
          reconsultarTransaccionPendiente();
      }else if (
        typeof resp?.data.data === "undefined" ||
        Object.keys(resp?.data.data.data).length < 2
      ) {
        window.location.href = "/";
      } else if (resp?.data.exito) {
        setresultadoVacio(false);
        setRespEPayco(resp?.data.data.data.log);
        setNombreDashboard(resp?.data.data.nombreDashboard);
        setIpoconsumo(resp?.data.data.ipoconsumo);
      }

      if(respEpayco.x_respuesta === "Pendiente"){
        reconsultarTransaccionPendiente();
      }
    };

    function reconsultarTransaccionPendiente(){
      console.log("ejecutando");
      setContador(16);
      contador = 16;
      var interval = setInterval(function(){
        contador--
        setContador(contador);
        if(contador === 0){
          console.log("clear");
          setresultadoVacio(false);
          clearInterval(interval);  
          consultarDetalleRefEpayco(setPantallaBloqueada);
        }
      }, 1000)
    }

    consultarDetalleRefEpayco(setPantallaBloqueada);
    
  }, [ref_payco, id_cliente, respEpayco.x_respuesta]);
  

  
  

  return (
    <BlockUi blocking={pantallaBloqueada} loader={_loader}>
      <div
        id="contenedor-principal-pagos-online"
        className={nombreDashboard == null ? "vh-100" : ""}
      >
        

        <div className="comprobanteContainer">
          <br></br>
          <table id="bodyTable">
            <tbody>
              <tr>
                <td align="center" valign="top" id="bodyCell">
                  {/*** CONTAINER MESSAGER PRIMARY  **/}
                  {
                    resultadoVacio && 
                    (<div className="card line no-print mt-10">
                        Su transacción se encuentra aún en proceso de verificación por parte de las entidades bancarias.
                        <br></br> Podrá descargar su comprobante de pago cuando su pago haya sido validado.
                        <br></br>
                        <i className={resultadoVacio ? "" : "d-none"}>volviendo a consultar en: {contador} segundos</i>
                    </div>)
                  }
                  <div
                    className={
                      "container " + (nombreDashboard == null ? " d-none" : "")
                    }
                  >
                    {/*** LOGO EPAYCO  **/}

                    {/*** BODY MESSAGE  **/}
                    <div className="content shadow">
                      <div className="head azul">
                        <div className="card line cardHead  row">
                          <div className="logoRecaudo col">
                            <img
                              src="https://369969691f476073508a-60bf0867add971908d4f26a64519c2aa.ssl.cf5.rackcdn.com/logos_clientes/597350_1644346242.png"
                              alt="logo"
                              height={"64px"}
                              width={"64px"}
                            />
                          </div>
                          <div className="nombreRecaudo col fs-4 mt-10">
                            {" "}
                            {nombreDashboard}
                          </div>
                        </div>
                      </div>
                      {/*** SEPARADOR START **/}
                      <div style={{ height: "40px" }}></div>
                      {/*** SEPARADOR END **/}
                      <div className="card line no-print">
                        <strong className="title">
                          Hola,{" "}
                          {respEpayco.x_customer_name +
                            " " +
                            respEpayco.x_customer_lastname}
                        </strong>
                        <span className="text">
                          Ha realizado una transacción a favor de{" "}
                          <strong> {nombreDashboard} </strong>
                        </span>
                        <span className="title status">
                          Transacción {respEpayco.x_respuesta}
                          <br />
                          <strong className="text-ins">
                            ${MoneyMask(respEpayco.x_amount + "")}{" "}
                            {respEpayco.x_currency_code}
                          </strong>
                          <br></br>
                          <i className={respEpayco.x_respuesta === "Pendiente"? "" : "d-none"}>La transacción esta en estado {respEpayco.x_respuesta}</i>
                          <br></br>
                          <i className={respEpayco.x_respuesta === "Pendiente" ? "" : "d-none"}>volviendo a consultar en: {contador} segundos</i>
                        </span>
                      </div>
                      {/*** DETAIL PAYER **/}
                      <div className="card line payer">
                        <strong className="text">Detalle del Pagador</strong>

                        <div className="row mt-6">
                          <div className="col text-start">
                            <strong>Documento y/o Nit </strong>
                          </div>
                          <div className="col text-end">
                            <span>{respEpayco.x_customer_document}</span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>Nombres o Razón Social</strong>
                          </div>
                          <div className="col text-end">
                            <span>
                              {respEpayco.x_customer_name +
                                " " +
                                respEpayco.x_customer_lastname}
                            </span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>Teléfono / Celular</strong>
                          </div>
                          <div className="col text-end">
                            <span>
                              {respEpayco.x_customer_phone} /{" "}
                              {respEpayco.x_customer_movil}
                            </span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>Email</strong>
                          </div>
                          <div className="col text-end">
                            <span>{respEpayco.x_customer_email}</span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>País</strong>
                          </div>
                          <div className="col text-end">
                            <span>{respEpayco.x_customer_country}</span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>Ciudad</strong>
                          </div>
                          <div className="col text-end">
                            <span>{respEpayco.x_customer_city}</span>
                          </div>
                        </div>
                      </div>
                      {/*** DETAIL TRNASACTION **/}
                      <div className="card line">
                        <strong className="text">
                          Detalle de la transacción
                        </strong>

                        <div className="row mt-6">
                          <div className="col text-start">
                            <strong>Descripción</strong>
                          </div>
                          <div className="col text-end">
                            <span>{respEpayco.x_description}</span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>Referencia ePayco</strong>
                          </div>
                          <div className="col text-end">
                            <span>{respEpayco.x_ref_payco}</span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col-md-4 text-start">
                            <strong>Referencia Comercio</strong>
                          </div>
                          <div className="col-md-8 text-end">
                            <span>{respEpayco.x_extra1}</span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>Fecha y hora transacción</strong>
                          </div>
                          <div className="col text-end">
                            <span>{respEpayco.x_transaction_date}</span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>Medio de pago</strong>
                          </div>
                          <div className="col text-end">
                            <span> {respEpayco.x_franchise} </span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>Banco</strong>
                          </div>
                          <div className="col text-end">
                            <span> {respEpayco.x_bank_name}</span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>Estado</strong>
                          </div>
                          <div className="col text-end">
                            <span>{respEpayco.x_transaction_state}</span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>Valor</strong>
                          </div>
                          <div className="col text-end">
                            <span>
                              ${MoneyMask(respEpayco.x_amount + "")}{" "}
                              {respEpayco.x_currency_code}
                            </span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>IVA</strong>
                          </div>
                          <div className="col text-end">
                            <span>
                              ${MoneyMask(respEpayco.x_tax + "")}{" "}
                              {respEpayco.x_currency_code}
                            </span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>Total</strong>
                          </div>
                          <div className="col text-end">
                            <span>
                              ${MoneyMask(respEpayco.x_amount_ok + "")}{" "}
                              {respEpayco.x_currency_code}
                            </span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>Impoconsumo</strong>
                          </div>
                          <div className="col text-end">
                            <span>{ipoconsumo > 0 ? ipoconsumo : "-"}</span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>Nro. Recibo</strong>
                          </div>
                          <div className="col text-end">
                            <span>{respEpayco.x_transaction_id}</span>
                          </div>
                        </div>

                        <div className="row mt-1">
                          <div className="col text-start">
                            <strong>Autorización / CUS</strong>
                          </div>
                          <div className="col text-end">
                            <span>{respEpayco.x_approval_code}</span>
                          </div>
                        </div>
                        <a href="/" className="text-ins no-print">
                          <FontAwesomeIcon icon={"sync"} /> Realizar otro pago
                        </a>
                      </div>
                      <button
                        className="btn btn-lg btn-comfe col-md-12 col-lg-12 col-xs-12 no-print"
                        onClick={() => {
                          window.print();
                        }}
                      >
                        <FontAwesomeIcon icon={"print"} size="2x" /> Imprimir
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </BlockUi>
  );
};
export { DescargarComprobantePago };
